module.exports = __webpack_public_path__ + "assets/img/mCare_d_p1.e75b2703.png";